// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"q_bz","stickyArticleHeaderContainer":"q_bB","stickyArticleHeaderButton":"q_bC","text_left":"q_bD","progressContainer":"q_bF","progressBar":"q_bG"};